require('slick-carousel');

export function sl1() {
  $('[data-sl1]').slick({
    dots: true,
    arrows: false,
  });
}
